import { Component, type ReactNode } from 'react'
import { captureError } from '@/lib/errorReporting'
import { ErrorState } from '@/design'

interface Props {
  children: ReactNode
}
interface State {
  hasError: boolean
}

/** Top-level React error boundary (amendment A3): catches render errors anywhere in the tree. */
export class RootErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: unknown, info: unknown): void {
    captureError(error, { boundary: 'root', info })
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-background p-6">
          <div className="w-full max-w-md">
            <ErrorState
              title="The app hit an unexpected error"
              message="Try reloading. If this keeps happening, contact support."
              onRetry={() => window.location.reload()}
            />
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
